import React from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";

function Contact() {
  return (
    <div className="app">
      <Header />
      <div className="app_body">
        <h2>contact</h2>
      </div>
      <Footer />
    </div>
  );
}

export default Contact;
